import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { schemas } from '@convergence/client';

export function useAnalysisCostQuery(slug: string | undefined) {
  const q = useQuery({
    enabled: !!slug,
    queryKey: ['analysis', 'cost', slug],
    queryFn: async () => {
      const data = await fetch(
        `/analysis/${slug}/cost`,
        { method: 'GET' },
        schemas.AnalysisCostBreakdownDto
      );
      return data;
    },
    retry: false
  });

  return q;
}
